import { AuthenticatedLayout } from "@components/layouts/AuthenticatedLayout";
import { ContactsListView } from "@/containers/contacts/ContactsListView";

const ContactsPage = () => {
    return (
        <AuthenticatedLayout activeMenuItem="contacts">
            <ContactsListView />
        </AuthenticatedLayout>
    );
}

export default ContactsPage;